import http, { AUTH_ROUTES } from "../../../services/api";

export const getPaymentRecord = async (
  paymentId,
  setPaymentRecord,
  setLoading,
  estateId,
  { limit = 10, skip = 0, commodityType } = {},
  setTotalRecords,
) => {
  try {
    const result = await http.get(
      AUTH_ROUTES.GET_PAYMENT_RECORD(paymentId, estateId, { limit, skip, commodityType }),
    );
    const userDetails = result?.data?.userDetails || result?.data;
    let possibleData = [];
    let total = 0;

    if (userDetails?.data?.billsPayment) {
      possibleData = userDetails.data.billsPayment;
      total = userDetails.data.totalRecords ?? possibleData.length;
    } else if (Array.isArray(userDetails?.data)) {
      possibleData = userDetails.data;
      total = possibleData.length;
    } else if (Array.isArray(userDetails)) {
      possibleData = userDetails;
      total = possibleData.length;
    } else if (Array.isArray(result?.data)) {
      possibleData = result.data;
      total = possibleData.length;
    }

    setPaymentRecord(possibleData || []);
    if (setTotalRecords) setTotalRecords(total);
  } catch (e) {
    console.error("getPaymentRecord error", e?.response || e?.message || e);
    setPaymentRecord([]);
    if (setTotalRecords) setTotalRecords(0);
  } finally {
    setLoading(false);
  }
};
